
import Expanded from './expanded.vue'
import Onboarding from './onboarding.vue'

export default {
  components: {Expanded, Onboarding},
  props: {
    chatId: {type: String, default: undefined},
    mode: {type: String, required: true},
    item: {type: Object, required: true},
    lastAnswer: {type: Boolean, default: false},
    generating: {type: Boolean, default: false},
    idx: {type: Number, default: 0},
    readonly: {type: Boolean, default: false},
    restricted: {type: Boolean, default: false},
  },
  emits: [
    'text-added', 'ask-ai', 'refrag', 
    'save', 'dislike', 'like', 
    'onboarding-completed', 'meeting-save', 'podcast-save'
  ],
  computed: {
    data(){
      return this.item?.data
    }
  },
  created() {
    this.$listen('meeting-save', () => this.$emit('meeting-save'))
    this.$listen('document-save', this.saveDocument)
    this.$listen('podcast-save', () => this.$emit('podcast-save'))
  },
  methods: {
    saveDocument(args = {}) {
      const {card_idx, ext} = args
      this.$dispatch('document-save', {
        history_idx: this.idx,
        card_idx,
        ext
      })
    },
    getAnswerTabs(){
      return this.$refs.expanded.getAnswerTabs()
    }
  },

}
